<template>
    <div class="component_wrapper" v-click_outside="close_results">
        <div class="search_bar" :style="this.display_results || this.api_autocompletes.length > 0 ? 'border-radius: 10px 10px 0 0;' : 'border-radius: 10px;'">
            <input type="text" ref="search" @input="updateOnInput" v-model="displayed_search_string" @keypress.enter="selectedSuggestion == -1 ? query_search() : finalize_autocompletion(api_autocompletes[selectedSuggestion]['original'], api_autocompletes[selectedSuggestion]['id'])" @keyup="moveAutocompleteSelection" :placeholder="$t('Search keywords and Authors') + '...'" :style="displayed_search_string.length>0? 'width: calc(78% - 30px);' : 'width: 78%;'">
            <button v-if="displayed_search_string.length>0" type="reset" @click="reset_search_string">✖</button>
            <button type="submit" @click="query_search">🔍</button>
        </div>

        <div class="autocomplete" :style="this.api_autocompletes.length > 0 ? 'box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); height: auto; padding: 7px 0;' : 'padding: 0; height: 0; box-shadow: none; -moz-box-shadow: none; -webkit-box-shadow: none;'">
            <div class="autocomplete_item" v-for="(element, index) in this.api_autocompletes" v-bind:key="typeof(element['original'])==='string' ? element['original'] : element['original'][0]"> 
                <div :style="index == selectedSuggestion ? 'cursor: pointer; padding: 5px 15px; background: #0077C830;' : 'cursor: pointer; padding: 5px 15px; background: none;'" @click="finalize_autocompletion(element['original'], element['id'])"> 
                    <h1>{{combine_autocomplete_entry_names(element['original'])}}</h1>
                    <p v-if="element['original'][0] != element['id'][0]">{{combine_autocomplete_entry_names(element['id'])}}</p>
                </div>
                <hr v-if="element !== api_autocompletes[api_autocompletes.length -1]">
            </div>
        </div>

        <div v-if="this.show_hidden_warning" class="hidden-warning" :style="this.display_results&&this.$store.getters.amagar_nodes ? 'margin-top: 5px; box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); height: min-content;' : 'height: 0; margin-top: 0; box-shadow: none; -moz-box-shadow: none; -webkit-box-shadow: none;'">
            <h1>!</h1>
            <p>{{ $t("Search results aren't displayed on the graph if '{0}' option is checked", [$t("Hide nodes")]) }}.</p>
            <button @click="show_hidden_warning=false">{{ $t("Don't show again") }}</button>
        </div>
        
        <vue-custom-scrollbar class="search_results" ref="results_scroll" :style="this.display_results ? 'box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6); height: 70vh;' : 'height: 0; box-shadow: none; -moz-box-shadow: none; -webkit-box-shadow: none;'">
            <div class="result" v-for="element in this.api_results_page" v-bind:key="element['id_node']">
                <div :style="element['id_node'] == selected_node ? 'cursor: pointer; background: #0077C830; padding: 5px;' : 'cursor: pointer; background: none; padding: 5px;'" @click="select_node(element['id_node'], element['x'], element['y'])">
                    <h1>{{element['label']}}</h1>
                    <p>{{ $t("Contains") }}: {{element['has_words'].join(', ')}}</p>
                </div>
                <hr v-if="element !== api_results[api_results.length -1]">
                <hr v-else-if="api_recommendations['words'].length > 0 || api_recommendations['authors'].length > 0">
            </div>
            <div class="word_recommendations result" v-if="this.display_results && this.api_results.length > 0 && api_recommendations['words'].length > 0">
                <h3>{{ $t("Related words") }}:</h3>
                <p style="margin-bottom: 10px;">ⓘ {{ $t("The 10 words that most commonly appear in publications with words in the query") }}.</p>
                <button v-for="recommended in this.api_recommendations['words']" v-bind:key="recommended" @click="toggle_related_word(recommended)" :style="word_list.includes(recommended) ? 'background: #07d60050;' : 'background: #0078c82a;'">{{recommended}}</button>
            </div>
            <div class="word_recommendations result" v-if="this.display_results && this.api_results.length > 0 && api_recommendations['authors'].length > 0">
                <h3>{{ $t("Related authors") }}:</h3>
                <p v-if="this.api_recommendations['authors'].length < 10" style="margin-bottom: 10px;">ⓘ {{ $t("The only {0} authors that have co-written publications with authors in the query", [api_recommendations['authors'].length]) }}.</p>
                <p v-else style="margin-bottom: 10px;">ⓘ {{ $t("The 10 authors that have co-written the most publications with authors in the query") }}.</p>
                <button v-for="recommended in this.api_recommendations['authors']" v-bind:key="recommended" @click="toggle_related_author(recommended)" :style="author_list.includes(recommended) ? 'background: #07d60050;' : 'background: #0078c82a;'">{{recommended}}</button>
            </div>
            <div class="result" v-if="this.display_results && this.api_results.length === 0" style="display: flex; flex-direction: column; justify-content: center; height: 320px;">
                <p style="text-align: center; margin-bottom: 10px;"> {{ $t("No results found") }}.</p>
                <p style="text-align: left; margin: 7px 5%;" > {{ $t("Suggestions") }}:</p>
                <p style="text-align: left; margin: 2px 10%;"> - {{ $t("Keywords") }}</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("All words should be in English and in lowercase") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Words should be separated by commas") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Words with blank spaces will be treated as separate words") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Check for misspellings (similar words are shown below)") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Try more general keywords") }}.</p>
                <p style="text-align: left; margin: 6px 10% 2px;"> - {{ $t("Authors") }}</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("All author names should start with an uppercase letter") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Author names should be separated by commas") }}.</p>
                <p style="text-align: left; margin: 2px 5% 2px 15%;"> · {{ $t("Check for misspellings (similar author names are shown below)") }}.</p>
            </div>
            <div class="word_recommendations" v-if="this.display_results && this.api_results.length === 0 && (api_recommendations['words'].length > 0 || api_recommendations['authors'].length > 0)"> <h3 style="font-size: 12px">{{ $t("Did you mean") }}...</h3> </div>
            <div class="word_recommendations" v-if="this.display_results && this.api_results.length === 0 && api_recommendations['words'].length > 0">
                <button v-for="recommended in this.api_recommendations['words']" v-bind:key="recommended" @click="replace_related_word(recommended)" :style="word_list.includes(recommended) ? 'background: #07d60050;' : 'background: #0078c82a;'">{{recommended}}</button>
            </div>
            <div class="word_recommendations" v-if="this.display_results && this.api_results.length === 0 && api_recommendations['authors'].length > 0">
                <hr v-if="api_recommendations['words'].length > 0">
                <button v-for="recommended in this.api_recommendations['authors']" v-bind:key="recommended" @click="replace_related_author(recommended)" :style="author_list.includes(recommended) ? 'background: #07d60050;' : 'background: #0078c82a;'">{{recommended}}</button>
            </div>
        </vue-custom-scrollbar>

        <div class="results_extra_controls" v-if="this.display_results && this.api_results.length > this.page_size">
            <button @click="decrement_page" style="border-radius: 10px 0 0 10px; border-right: 2px solid rgb(54, 57, 62);">↶</button>
            <div style="padding: 2px 0;">
                <p>{{ this.result_page*this.page_size+1 }}-{{ Math.min((this.result_page+1)*this.page_size, this.api_results.length) }} / {{ this.api_results.length }}</p>
            </div>
            <button @click="increment_page" style="border-radius: 0 10px 10px 0; border-left: 2px solid rgb(54, 57, 62);">↷</button>
        </div>
    </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
    components: {
        vueCustomScrollbar
    },
    name: "Cercador",
    data () {
        return {
            displayed_search_string: "",
            search_string: "",
            previous_search: "",
            word_list: [],
            author_list: [],
            display_results: false,
            api_results: [],
            api_recommendations: {'words':[], 'authors':[]},
            api_autocompletes: [],
            selectedSuggestion: -1,
            selected_node: "",
            results_nodes_ids: [],
            show_hidden_warning: true,
            result_page: 0,
            page_size: 15
        }
    },
    computed: {
        api_results_page() {
            return this.api_results.slice(this.result_page*this.page_size, (this.result_page + 1)*this.page_size);
        }
    },
    methods: {
        updateOnInput: function () {
            let allNewInputs = this.obtainUntreatedInputs();
            if (allNewInputs.length == 0) return;

            for (let i = 0; i < allNewInputs.length; i++) {
                let inp = allNewInputs[i];
                if (inp == '') continue;
                if (this.isLowerCase(inp[0])) { // input és una paraula
                    this.search_string += "W";
                    this.word_list.push(inp);
                }
                else if (i < allNewInputs.length-1 && allNewInputs[i+1].length > 0) { // input és un autor, mirem el següent per saber si afegir-lo o si no ha acabat encara
                    i++;
                    if (!this.isLowerCase(allNewInputs[i][0])) { // següent és part d'aquest autor
                        this.search_string += "A";
                        this.author_list.push((inp + ', ' + allNewInputs[i]));
                    } 
                    else { // següent és una paraula
                        this.search_string += "A";
                        this.author_list.push(inp);
                        i--;
                    }
                }
            }
            // OJO: si el últim input és un autor sense coma no s'afegeix a les llistes, per tant cal afegir-lo al fer la query

            if (this.displayed_search_string.length < 2) { this.api_autocompletes = []; this.selectedSuggestion = -1; return; }

            let toAutocomplete = this.obtainToAutocomplete();
            
            // Fem crides a completar a partir de dos caràcters per donar resultats mig decents
            if (toAutocomplete.length >= 3) this.query_autocomplete(toAutocomplete);
            else {this.api_autocompletes = []; this.selectedSuggestion = -1;} // amagar els autocompletes si 
        },
        isLowerCase(letter) { return letter == letter.toLowerCase() && letter != letter.toUpperCase(); },
        obtainUntreatedInputs() {
            let allNewInputs = this.displayed_search_string.split(',').map(el => el.trim());
            let wIdx = 0, aIdx = 0, sIdx = 0;
            for (sIdx; sIdx < this.search_string.length; sIdx++) {
                if (this.search_string[sIdx] === 'W') {
                    let curr_word = typeof(this.word_list[wIdx]) === 'string' ? this.word_list[wIdx] : this.word_list[wIdx][0];
                    if (curr_word == allNewInputs[0]) { allNewInputs.shift(); }
                    else break;
                    wIdx++;
                } else {
                    let curr_author = typeof(this.author_list[aIdx])==='string' 
                        ? this.author_list[aIdx].split(',').map(el => el.trim())
                        : this.author_list[aIdx][0].split(',').map(el => el.trim());
                    if (curr_author.length === 2 && curr_author[0] == allNewInputs[0] && curr_author[1] == allNewInputs[1]) { allNewInputs.shift(); allNewInputs.shift(); }
                    else if (curr_author.length === 1 && curr_author[0] == allNewInputs[0]) allNewInputs.shift();
                    else break;
                    aIdx++;
                }
            }
            this.search_string = this.search_string.slice(0,sIdx);
            this.word_list = this.word_list.slice(0,wIdx);
            this.author_list = this.author_list.slice(0,aIdx);
            return allNewInputs;
        },
        obtainToAutocomplete() {
            let toAutocomplete;
            if (this.search_string == '') { // Escrivint un Author
                toAutocomplete = this.displayed_search_string.trim();
            } else if (this.search_string[this.search_string.length - 1] == 'W') {
                let last_word = typeof(this.word_list[this.word_list.length-1])==='string'
                    ? this.word_list[this.word_list.length-1]
                    : this.word_list[this.word_list.length-1][0];
                let comp = this.displayed_search_string.split(last_word).map(el => el.trim()); // potser Author
                toAutocomplete = comp[comp.length -1];
                if (toAutocomplete == '') // estem autocompletant la pròpia Word
                    toAutocomplete = last_word;
            } else if (this.search_string[this.search_string.length - 1] == 'A') { // Escrivint un Author després d'haver-hi un autor al final de la llista
                let last_author = typeof(this.author_list[this.author_list.length-1])==='string'
                    ? this.author_list[this.author_list.length-1]
                    : this.author_list[this.author_list.length-1][0];
                let comp = this.displayed_search_string.split(last_author).map(el => el.trim());
                toAutocomplete = comp[comp.length -1];
                if (toAutocomplete == '') // estem autocompletant el propi autor
                    toAutocomplete = last_author;
            }
            
            // treure les comes de davant i darrere el nou input
            if (toAutocomplete[0] == ',') toAutocomplete = toAutocomplete.substring(1,toAutocomplete.length).trim();
            if (toAutocomplete[toAutocomplete.length - 1] == ',') toAutocomplete = toAutocomplete.substring(0,toAutocomplete.length-1).trim();
            
            return toAutocomplete;
        },
        sortAllUntreatedInputs() {
            let allNewInputs = this.obtainUntreatedInputs();
            let prevAuthor = false;
            for (let i = 0; i < allNewInputs.length; i++) {
                let inp = allNewInputs[i];
                if (inp == '') continue;
                if (this.isLowerCase(inp[0])) {
                    this.search_string += "W";
                    this.word_list.push(inp);
                } else if (prevAuthor) {
                    prevAuthor = false;
                    this.author_list[this.author_list.length-1] += ", "+inp;
                } else {
                    prevAuthor = true;
                    this.search_string += "A";
                    this.author_list.push(inp);
                }
            }
        },
        query_search: function() {
            // clear autocompletes
            this.api_autocompletes = [];
            this.selectedSuggestion = -1;

            // add evrything that hasn't been added
            this.sortAllUntreatedInputs();

            if (this.search_string.length == 0) {
                console.log('NOTHING TO QUERY');
                return;
            }
            if (this.displayed_search_string == this.previous_search) {
                console.log('SAME QUERY');
                this.display_results = true;
                this.$root.$emit('SearchResultsIds', this.results_nodes_ids);
                return;
            }
            // save previous search to not have to re-query the same results
            this.previous_search = this.displayed_search_string;

            // build the query string
            let url =
                this.$store.getters.api_url +
                "/search_keywords?keywords=";
            for(let i = 0; i < this.word_list.length; i++) {
                if (i > 0) url += '%23';
                if (typeof(this.word_list[i]) === 'string') { url += this.word_list[i].replaceAll(' ','%23'); }
                else {
                    for (let j = 0; j < this.word_list[i].length; j++) {
                        if (j > 0) url += '%23';
                        url += this.word_list[i][j].replaceAll(' ','%23');
                    }
                }
            }
            for(let i = 0; i < this.author_list.length; i++) {
                if (i > 0 || this.word_list.length > 0) url += '%23';
                if (typeof(this.author_list[i]) === 'string') { url += this.author_list[i]; }
                else {
                    for (let j = 0; j < this.author_list[i].length; j++) {
                        if (j > 0) url += '%23';
                        url += this.author_list[i][j];
                    }
                }
            }

            var self = this;
            return new Promise((resolve) => {
                this.$api
                .get(url)
                .then(function(response) {
                    self.display_results = true;
                    self.result_page = 0;
                    self.api_results = response.data["results"];
                    self.api_recommendations = response.data["recommendations"];
                    self.results_nodes_ids = [];
                    self.api_results.forEach((e) => self.results_nodes_ids.push(e['id_node']));
                    self.$root.$emit('SearchResultsIds', self.results_nodes_ids);
                    resolve(self.api_results, self.api_recommendations);
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                    self.display_results = true;
                    self.api_results = [];
                    self.api_recommendations = {'words':[], 'authors':[]}
                    resolve(self.api_results, self.api_recommendations);
                });
            });
        },
        query_autocomplete: function(input) {
            let encoded_input = input.replaceAll(',','%2C').replaceAll('.','%2E').replaceAll(' ','%20');
            let url =
                this.$store.getters.api_url +
                "/autocomplete?search="+
                encoded_input;
            var self = this;
            return new Promise((resolve) => {
                this.$api
                .get(url)
                .then(function(response) {
                    self.api_autocompletes = response.data;
                    self.selectedSuggestion = -1;
                    resolve(self.api_autocompletes);
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                    self.api_autocompletes = [];
                    self.selectedSuggestion = -1;
                    resolve(self.api_autocompletes);
                });
            });
        },
        select_node: function(node) {
            this.$root.$emit("SearchSelectNode", node);
            this.selected_node = node;
            this.$root.$emit("SearchResultsIds", [node]);
        },
        close_results: function() {
            if(this.display_results) this.display_results = false;
            this.api_autocompletes = [];
            this.selectedSuggestion = -1;
        },
        moveAutocompleteSelection: function(event) {
            if (this.api_autocompletes.length == 0) return;
            if (event.keyCode == 40) {
                this.selectedSuggestion ++;
                if (this.selectedSuggestion >= this.api_autocompletes.length) this.selectedSuggestion = -1;
            } else if (event.keyCode == 38) {
                this.selectedSuggestion --;
                if (this.selectedSuggestion < -1) this.selectedSuggestion = this.api_autocompletes.length -1;
            } else return;
        },
        finalize_autocompletion: function(original, id) {
            let toReplace = this.obtainToAutocomplete();
            let idxReplace = this.displayed_search_string.lastIndexOf(toReplace);
            if (idxReplace < 0) return;
            if (idxReplace + toReplace.length >= this.displayed_search_string.length) 
                this.displayed_search_string = this.displayed_search_string.substring(0,idxReplace);
            
            let strToAdd = typeof(id) === 'string' ? id : id[0];
            if (this.isLowerCase(original[0][0])) {
                this.search_string += 'W';
                this.word_list.push(id);
                let trimedDisp = this.displayed_search_string.trim();
                if (this.search_string == 'W' || this.displayed_search_string == '') this.displayed_search_string = strToAdd+', ';
                else if (trimedDisp[trimedDisp.trim().length - 1] == ',') this.displayed_search_string = trimedDisp + ' '+strToAdd+', ';
                else this.displayed_search_string = trimedDisp + ', '+strToAdd+', ';
            } else {
                this.search_string += 'A';
                this.author_list.push(id);
                let trimedDisp = this.displayed_search_string.trim();
                if (this.search_string == 'A') this.displayed_search_string = strToAdd;
                else if (trimedDisp[trimedDisp.length - 1] == ',') this.displayed_search_string = trimedDisp + ' '+strToAdd+', ';
                else this.displayed_search_string = trimedDisp + ', '+strToAdd+', ';
            }
            this.api_autocompletes = [];
            this.selectedSuggestion = -1;
            this.$refs.search.focus();
        },
        combine_autocomplete_entry_names: function(name_list) {
            if (typeof(name_list) === 'string') return name_list;
            let ret = name_list[0];
            if (name_list.length > 1) { 
                ret += ' ('; 
                for (let i = 1; i < name_list.length-1; i++) {
                    ret += name_list[i]+', '
                }
                ret += name_list[name_list.length-1]+')';
            }
            return ret;
        },
        reset_search_string: function() {
            this.displayed_search_string='';
            this.search_string='';
            this.word_list = [];
            this.author_list = [];
            this.api_autocompletes = [];
            this.selectedSuggestion = -1;
            if (this.results_nodes_ids.length != 0)
                this.$root.$emit("SearchResultsIds", []);
            this.$refs.search.focus();
        },
        toggle_related_word: function(word) {
            let wIdx = this.word_list.indexOf(word);
            if (wIdx === -1) { 
                // add everything that hasn't been added
                this.sortAllUntreatedInputs();
                // add the new word to the list and the placeholder
                this.search_string += 'W';
                this.word_list.push(word);
                let trimedDisp = this.displayed_search_string.trim();
                if (this.search_string == 'W') this.displayed_search_string = word;
                else if (trimedDisp[trimedDisp.length - 1] == ',') this.displayed_search_string = trimedDisp + ' '+word;
                else this.displayed_search_string = trimedDisp + ', '+word;
                this.$refs.search.focus();
            } else { 
                // remove the word from the list and the placeholder
                this.word_list.splice(wIdx, 1);
                let auxIdx = 0;
                for (let i = 0; i <= this.search_string.length; i++) {
                    if (this.search_string[i] == 'W') {
                        if (auxIdx === wIdx) {
                            this.search_string = this.search_string.substring(0,i) + this.search_string.substring(i+1,this.search_string.length)
                            let twoHalves = this.displayed_search_string.split(word).map(el => el.trim());
                            this.displayed_search_string = (twoHalves[0] + twoHalves[1]).replaceAll(',,',',');
                            if (this.displayed_search_string[0] == ',') 
                                this.displayed_search_string = this.displayed_search_string.substring(1,this.displayed_search_string.length).trim();
                            return;
                        }
                        auxIdx ++;
                    } 
                }
            }
        },
        replace_related_word: function(word) {
            if (this.displayed_search_string == this.previous_search) {
                this.displayed_search_string='';
                this.search_string='';
                this.word_list = [];
                this.author_list = [];
            }
            this.toggle_related_word(word);
        },
        toggle_related_author: function(author) {
            let aIdx = this.author_list.indexOf(author);
            if (aIdx === -1) { 
                // add everything that hasn't been added
                this.sortAllUntreatedInputs();
                // add the new author to the list and the placeholder
                this.search_string += 'A';
                this.author_list.push(author);
                let trimedDisp = this.displayed_search_string.trim();
                if (this.search_string == 'A') this.displayed_search_string = author;
                else if (trimedDisp[trimedDisp.length - 1] == ',') this.displayed_search_string = trimedDisp + ' '+author;
                else this.displayed_search_string = trimedDisp + ', '+author;
                this.$refs.search.focus();
            } else { 
                // remove the author from the list and the placeholder
                this.author_list.splice(aIdx, 1);
                let auxIdx = 0;
                for (let i = 0; i <= this.search_string.length; i++) {
                    if (this.search_string[i] == 'A') {
                        if (auxIdx === aIdx) {
                            this.search_string = this.search_string.substring(0,i) + this.search_string.substring(i+1,this.search_string.length)
                            let twoHalves = this.displayed_search_string.split(author).map(el => el.trim());
                            this.displayed_search_string = (twoHalves[0] + twoHalves[1]).replaceAll(',,',',');
                            if (this.displayed_search_string[0] == ',') 
                                this.displayed_search_string = this.displayed_search_string.substring(1,this.displayed_search_string.length).trim();
                            return;
                        }
                        auxIdx ++;
                    } 
                }
            }
        },
        replace_related_author: function(author) {
            if (this.displayed_search_string == this.previous_search) {
                this.displayed_search_string='';
                this.search_string='';
                this.word_list = [];
                this.author_list = [];
            }
            this.toggle_related_author(author);
        },
        increment_page: function() {
            if (this.result_page+1 < this.api_results.length / this.page_size) this.result_page += 1;
            console.log(this.result_page);
        },
        decrement_page: function() {
            if (this.result_page > 0) this.result_page -= 1;
            console.log(this.result_page);
        }
    },
    directives: {
        click_outside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('focusin', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('focusin', el.clickOutsideEvent)
            },
        },
    },
    mounted(){
        this.$root.$on('ToggleWordSearch', (word) => {
            this.toggle_related_word(word);
        });
        this.$root.$on('ToggleAuthorSearch', (author) => {
            this.toggle_related_author(author);
        });
        this.$store.subscribe((mutation) => {
            if (mutation.type === 'SeleccionaNode') {
                /*let nouNodeSeleccionat = this.api_results.find((e) => e['id_node'] === this.$store.getters.node_Seleccionat.id);
                if (nouNodeSeleccionat != undefined)
                    this.$root.$emit("SearchResultsPositions", [[nouNodeSeleccionat['x'],nouNodeSeleccionat['y']]]);
                /*else 
                    this.$root.$emit("SearchResultsPositions", []);*/
                this.selected_node = this.$store.getters.node_Seleccionat.id;
            } else if (mutation.type === 'AmagaInfo') {
                /*if (this.api_results.find((e) => e['id_node'] === this.selected_node) && this.search_string != '') {
                    this.$root.$emit("SearchResultsPositions", this.results_positions);
                }*/
                this.selected_node = "";
            }
            else if (mutation.type === 'reset') {
                this.displayed_search_string='';
                this.search_string='';
                this.word_list = [];
                this.author_list = [];
                this.api_autocompletes = [];
                this.selectedSuggestion = -1;
            }
        });
    },
    beforeDestroy(){
        this.$root.$off('ToggleWordSearch');
        this.$root.$off('ToggleAuthorSearch');
    }
}
</script>
<style scoped>
.component_wrapper {
    position: relative;
}

.search_bar {
    width: 100%;
    height: 30px;
    background: white;
    border: 1px solid white;
    overflow: hidden;
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    transition: border-radius 200ms;
}
.search_bar input[type=text] {
    height: 30px;
    float: left;
    padding: none;
    margin: 0 5px;
    width: 78%;
    color: black;
    background: white;
    border: none;
    border-radius: 0px;
    text-justify: center;
}
.search_bar input[type=text]:focus{
    outline: none;
}
.search_bar button[type=button] {
    display: inline;
    border: none;
    padding: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 11px;
    text-align: center;
    color: black;
    background: #07d60050;
}
.search_bar button[type=submit] {
    width: calc(20% - 10px);
    height: 30px;
    padding: none;
    float: right;
    text-align: center;
    border: none;
    border-radius: 0px;
    background: #0077C8;
    color: white;
    cursor: pointer;
}
.search_bar button[type=submit]:focus{
    outline: none;
}
.search_bar button[type=submit]:hover{
    background: rgb(0,83,162);
}
.search_bar button[type=reset] {
    width: 30px;
    height: 30px;
    padding: 0 0 2px 0;
    float: center;
    text-align: center;
    border: none;
    border-radius: 15px;
    background: white;
    color: rgb(50,50,50);
    cursor: pointer;
}
.search_bar button[type=reset]:focus{
    outline: none;
}
.search_bar button[type=reset]:hover{
    background: rgb(230,230,230);
}

.autocomplete {
    position: absolute;
    width: calc(100% + 2px);
    height: 0px;
    top: 32px;
    left: 0;
    margin-top: 5px;
    border: none;
    background: white;
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    transition: height 150ms;
    z-index: 1;
}

.autocomplete_item h1 {
    margin: 0;
    padding: none;
    padding-bottom: 5px;
    font-size: 14px;
    color: black;
}
.autocomplete_item p {
    margin: 0;
    padding: none;
    font-size: 11px;
    color: gray;
}
.autocomplete_item hr {
    border: none;
    margin: none;
    padding: none;
    height: 1px;
    background: lightgray;
}
@keyframes blink{
    0% { background: white; }
    50% { background: #fff99f; }
    100% { background: white; }
}
.hidden-warning {
    width: calc(100% + 2px);
    height: min-content;
    padding: none;
    border: none;
    background: white;
    overflow: hidden;
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    transition: height 200ms;
    display: grid;
    grid-template-columns: min-content auto max-content;
    align-items: center;
    animation: blink 2s infinite;
}
.hidden-warning h1 {
    color: red;
    margin: 0;
    padding: 3px 0 3px 10px;
}
.hidden-warning p {
    margin: 0;
    padding: 4px 10px;
    font-size: 11px;
    color: gray;
}
.hidden-warning button {
    margin: 3px;
    padding: 5px 5px;
    font-size: 11px;
    color: #0077C8;;
}

.search_results {
    width: calc(100% + 2px);
    height: 0px;
    margin-top: 5px;
    padding: none;
    border: none;
    background: white;
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    transition: height 200ms;
}
.result {
    margin: 10px;
}
.result h1 {
    margin: 0;
    padding: none;
    padding-bottom: 5px;
    font-size: 16px;
    color: black;
}
.result p {
    margin: 0;
    padding: none;
    font-size: 11px;
    color: gray;
}
.result hr {
    border: none;
    height: 1px;
    background: lightgray;
}
.word_recommendations {
    margin: 10px;
}
.word_recommendations h3 {
    font-size: 15px;
    color: black;
}
.word_recommendations button{
    margin: 3px;
    padding: 3px 10px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
}
.results_extra_controls {
    margin-top: 5px;
    background: white;
    display: grid;
    grid-template-columns: max-content 80px max-content;
    width: min-content;
    border-radius: 10px;
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -webkit-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.6);
}
.results_extra_controls p {
    margin: 0 2px;
    padding: 0 5px;
    text-align: center;
    font-size: 12px;
    color: black;
    vertical-align: middle;
}
.results_extra_controls button {
    background: none;
    border: none;
    cursor: pointer;
}
.results_extra_controls button:hover{
    background: lightgray;
}

</style>
